export const UPPSÖKANDEVERKSAMHET = 1;
export const VUXENTANDVÅRD = 5;
export const SPECIALISTTANDVÅRD = 4;
export const TANDREGLERING = 7;